import React, { Component } from 'react';
import { Spin, Tag, Divider, List, message } from 'antd';
import { connect } from 'dva';
import moment from 'moment';
import FilesUpload from 'nbugs-files-upload';
import Card from 'nbugs-mobile-card';
import { stringify } from 'qs';
import router from 'umi/router';
import { ENV } from '@/services/utils';
import index from '@/pages/Home/ActivitySign/Components/UnSignRemind';
import { GetQueryString, getAppCode } from '../../utils/utils';
import Container from '../../../../../components/Container';
import styles from './index.less';

const { Item } = List;
const statusIcon = {
  1: '#FAAD14',
  3: '#F5222D',
  4: '#1785EC',
  5: '#52C41A',
  7: '#52C41A',
  8: '#C3C3C3',
  10: '#C3C3C3',
};

const statusText = {
  1: '拟稿中',
  3: '被打回',
  4: '审批中',
  5: '审批成功',
  7: '已发布',
  8: '已撤下',
  10: '已撤回',
};

@connect(({ edit }) => {
  return {
    cfgData: edit.cfgData,
  };
})
class LeadershipApprovalDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailData: {},
      spinning: false,
      schoolType: '',
    };
    this.id = GetQueryString('detailId') || GetQueryString('id');
    this.appCode = getAppCode();
    this.type = GetQueryString('type');
  }

  componentDidMount() {
    this.fetchNewsById();
    this.fetchOrgType();
  }

  fetchNewsById = () => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'edit/fetchNewsById',
      params: { id: this.id },
    })
      .then(res => {
        this.setState({ spinning: false, detailData: res });
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchOrgType = () => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'leadershipApproval/fetchOrgType',
    })
      .then(res => {
        this.setState({ spinning: false, schoolType: res });
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  toRecord = detail => {
    const returnUrl = `${window.location.href.split('.com')[1]}`;
    const params = `?${stringify({
      id: detail.applyId,
      detailId: this.id,
      returnUrl,
    })}`;
    router.push(`${window.location.pathname}/workflow${params}`);
  };

  renderBasicInfo = () => {
    const { detailData = {}, schoolType } = this.state;
    const { needPush = '', needUp = '', needDown = '' } = detailData;
    const data = [
      {
        title: '是否需要发送消息提醒',
        isNeed: needPush,
      },
      {
        title: '是否需要上报给教育局',
        isNeed: needUp,
      },
    ];
    if (schoolType !== 'school') {
      data.push({
        title: needDown === '1' ? '是否需要同步给下属学校' : '是否需要同步给所有直属非直属学校',
        isNeed: needDown,
      });
    }
    return data.map(item => {
      return this.renderItem(item.title, item.isNeed, data.length);
    });
  };

  renderItem = (title, isNeed, length) => {
    return (
      <div className="itemInfo" style={{ width: `${100 / length}%` }}>
        <div className="itemTitle">{title}</div>
        <div className="itemValue">{isNeed === '1' || isNeed === '2' ? '需要' : '不需要'}</div>
      </div>
    );
  };

  // 渲染状态标签
  renderStatusTag = () => {
    const { detailData = {} } = this.state;
    const { status } = detailData;
    return (
      <Tag
        style={{
          background: 'white',
          border: `1px solid ${statusIcon[status] || "transparent"}`,
          color: `${statusIcon[status]}`,
        }}
      >
        {statusText[status]}
      </Tag>
    );
  };

  // 下载附件
  down = (url, fileName) => {
    try {
      this.getBlob(url).then(blob => {
        this.saveAs(blob, fileName);
      });
    } catch (error) {
      console.log(error);
    }
    return new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };

        xhr.send();

        xhr.onerror = error => {
          message.warning('服务器异常', 1);
          reject(error);
        };
      } catch (error) {
        reject(error);
      }
    });
  }

  getBlob = url => {
    return new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };

        xhr.send();

        xhr.onerror = error => {
          message.warning('服务器异常', 1);
          reject(error);
        };
      } catch (error) {
        reject(error);
      }
    });
  };

  saveAs = (blob, filename) => {
    try {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        const body = document.querySelector('body');

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = 'none';
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
      }
      message.success('下载成功');
    } catch (error) {
      console.log(error)
    }
  };

  render() {
    const { spinning, detailData = {} } = this.state;
    const {
      summary = '',
      title = '',
      coverPicFileUrl = '',
      newstype = '',
      content = '',
      url = '',
      fileId = '',
      applyId = 0,
      channel = {},
      gmtModify = '',
      outputDate = '',
      publishUserName,
      qrCode = '0',
      creatorUserName = '',
      status,
      files,
    } = detailData;
    const { cfgData } = this.props;
    const { iscustom, usercode, orgid } = cfgData;

    const pushTime = moment(outputDate || gmtModify).format('YYYY.MM.DD HH:mm') || null;

    return (
      <Container breStates={!0} version={2} isSplitBar>
        <div className={styles.root}>
          <Spin spinning={spinning}>
            <div className="top_part">
              <div className="first_part">
                <div className="title">
                  <div className="left">
                    <span className="verticalBar" />
                    <span>
                      {title}
                      {this.renderStatusTag()}
                    </span>
                  </div>
                  {applyId !== 0 && (
                    <div className="right">
                      <span className="opreationRecord" onClick={() => this.toRecord(detailData)}>
                        查看流转情况
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <Divider />
              <div className="textNews">
                <Item>
                  <span className="itemName">所在栏目</span>:
                  <Tag style={{ marginLeft: 16 }}>{channel?.title}</Tag>
                </Item>
                <Item>
                  <span className="itemName">{this.type === 'matter' ? '创建人' : '发布者'}</span>:
                  <span style={{ marginLeft: 16 }}>
                    {this.type === 'matter' ? creatorUserName : publishUserName}
                  </span>
                </Item>
                {!(status === 1 || this.type === 'matter') && (
                  <Item>
                    <span className="itemName">发布时间</span>:
                    <span style={{ marginLeft: 16 }}>{pushTime}</span>
                  </Item>
                )}
                <Item>
                  <span className="itemName">
                    {this.type === 'matter' ? '素材封面' : '文章封面'}
                  </span>
                  :
                  <span style={{ marginLeft: 16 }} className="cover_img">
                    <img src={coverPicFileUrl} alt="" />
                  </span>
                </Item>
                {summary && (
                  <Item>
                    <span className="itemName">文章摘要</span>:
                    <span style={{ marginLeft: 16 }}>{summary}</span>
                  </Item>
                )}
              </div>
            </div>
            <div className="second_part">
              <Divider orientation="left">{this.type === 'matter' ? "素材介绍" : "文章内容"}</Divider>
              <div>
                {(content && (newstype === '0' || this.type === 'matter')) && (
                  <Card maxHeight={160} wrapShowMode="normal">
                    <div dangerouslySetInnerHTML={{ __html: content }} style={{ width: '65%' }} />
                    {qrCode === '1' && usercode ? (
                      <div className="qrCode">
                        <img
                          src={
                            iscustom === 1
                              ? usercode
                              : `//classpic.oss-cn-hangzhou.aliyuncs.com/parent/qrCode/${orgid}.jpg`
                          }
                          alt=""
                        />
                      </div>
                    ) : null}
                  </Card>
                )}
                {!content && this.type === 'matter' && <div>暂无介绍</div>}
                {url && newstype === '1' && (
                  <Card maxHeight={160} wrapShowMode="normal">
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: 'underline',
                        wordBreak: 'break-all',
                      }}
                    >
                      {url}
                    </a>
                  </Card>
                )}
              </div>
              {fileId && (
                <div className="enclosure">
                  <Divider orientation="left">附件</Divider>
                  <div className="file-upload">
                    <FilesUpload
                      edit={1}
                      groupId={fileId}
                      type="pc"
                      callback={this.handleFileCallBack}
                      APIEnv={ENV}
                    />
                  </div>
                </div>
              )}
              {this.type === 'matter' && !fileId && files && (
                <>
                  <Divider orientation="left">素材文件</Divider>
                  {files.map((item) => {
                    return (
                      <div className="row-wrap" key={`${item.filename}-${index}`}>
                        <div className="video-title">
                          <img src="https://s.xiaoyuanhao.com/microsite/image/video_icon_img_n.svg" alt="" />
                          <div style={{ display: "inline-block" }}>
                            <div>{item.filename}</div>
                            <div className="size">{(item.filesize / 1024 / 1024).toFixed(2)}M</div>
                          </div>
                        </div>
                        <div className="down" onClick={() => { this.down(item.fileid, item.filename) }}>下载</div>
                      </div>
                    );
                  })}
                </>
              )}
              {!this.type && (
                <>
                  <Divider orientation="left">基础信息</Divider>
                  <div className="basicInfo">{this.renderBasicInfo()}</div>
                </>
              )}
            </div>
          </Spin>
        </div>
      </Container>
    );
  }
}

export default LeadershipApprovalDetails;
